export default "__VITE_ASSET__DQWnYk8t__"